export { default } from './ScripturePane';
